export function getCookieValue(name: string): string | undefined {
  const cookies = document.cookie;

  const match = cookies.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : undefined;
}

export function getFbcFromCookies(): string | undefined {
  return getCookieValue('_fbc');
}

export function getFbpFromCookies(): string | undefined {
  return getCookieValue('_fbp');
}

export function getShortsNinjaCookie(): Record<string, string> | undefined {
  const raw = getCookieValue('sn_tracking');
  if (!raw) return undefined;

  try {
    return JSON.parse(raw);
  } catch (e) {
    console.error('Invalid sn_tracking cookie JSON', e);
    return undefined;
  }
}
